import { Service } from 'aws-sdk/lib/service';
import axios from 'axios';
import {
  FETCH_AUTOMATIONS,
  RESET_AUTOMATIONS
} from '../actionTypes';
import { showAlert } from './alert';
import { hideLoader, showLoader } from './loader';

const SERVICE = `automations`;

export const fetchMyAutomation = trainerId => dispatch => {
	dispatch(showLoader());
	return new Promise(function (resolve, reject) {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get(SERVICE, {
				params: {
					creatorId: trainerId,
				},
			})
			.then(res => {
				dispatch(hideLoader());
				return resolve(res['data']);
			});
	});
};

export const resetAutomations = () => dispatch => {
	dispatch({
		type: RESET_AUTOMATIONS,
	});
};

export const fetchMoreAutomations = (query) => dispatch => {
	const promises = [];
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	promises.push(
		axios.get('automations', {
			params: query,
		})
	);
	if (query.skip === 0) {
		dispatch(showLoader());
	}
	return new Promise((respond, rej) => {
		Promise.all(promises).then(values => {
			const data = values[0].data;
			dispatch(hideLoader());
			dispatch({
				type: FETCH_AUTOMATIONS,
				payload: data,
			});
		});
	});
};

export const fetchAutomationDetail = (userId, automationId) => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get(`${SERVICE}/${automationId}`, {
				params: {
				},
			})
			.then(res => {
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(function (error) {
				console.warn(error);
				dispatch(hideLoader());
				reject();
			});
	});
};

export const editAutomation = (editId, instruction, user) => dispatch => {
	if (!editId) {
		console.error('automation does not have id');
		return false;
	}
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	return axios
		.patch(`${SERVICE}/${editId}`, instruction)
		.then(res => {
			dispatch(hideLoader());
			dispatch(showAlert('Automated message updated successfully.'));
		})
		.catch(function (error) {
			dispatch(hideLoader());
			dispatch(showAlert(error.toString(), true));
			console.warn(error);
		});
};

export const deleteAutomation = (id) => dispatch => {
	if (!id) {
		console.error('automation does not have id');
		return false;
	}
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	return axios
		.delete(`${SERVICE}/${id}`)
		.then(res => {
			dispatch(hideLoader());
			dispatch(showAlert('Automated Message deleted successfully.'));
			return res;
		})
		.catch(function (error) {
			dispatch(hideLoader());
			dispatch(showAlert(error.toString(), true));
		});
};



export const addAutomation = (automationData, user) => (dispatch, getState) => {
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	return axios
		.post(SERVICE, automationData)
		.then(res => {
			dispatch(hideLoader());
			if (res.data._id) {
				dispatch(showAlert('Automated Message added successfully.'));
			} else {
				console.error('Failed to add message.', automationData);
			}
		})
		.catch(function (error) {
			dispatch(hideLoader());
			console.warn(error);
			dispatch(showAlert('Failed to add message.', true));
		});
};




// WEBPACK FOOTER //
// ./src/store/actions/automations.js